<template>
  <v-carousel
    cycle
    interval="8000"
    height="450"
    hide-delimiter-background
    show-arrows-on-hover
  >
    <v-carousel-item v-for="(item, index) in itemsCarousel" :key="index">
      <v-responsive>
        <v-img
          gradient="to right, rgba(0,0,0,.9), rgba(0,0,0,0.05)"
          :src="lookupImageUrl(item)"
          min-height="450px"
        >
          <v-spacer></v-spacer>
          <div class="ml-8 mt-10">
            <v-card-title class="blue--text headline font-weight-black"
              >UMKM BERMITRA</v-card-title
            >
            <v-card-subtitle class="white--text">
              <v-row  class="hidden-sm-and-down">
                <v-col cols="12" sm="8" md="5">
                  UMKM (Usaha Mikro, Kecil, dan Menengah) yang Siap Bermitra merupakan Sarana Pemerintah untuk mempertemukan investor
                  dengan UMKM yang terverifikasi, memfasilitasi kemitraan dalam investasi dan kerjasama usaha yang terstruktur dan terpercaya.
                </v-col>
              </v-row>
              <v-row  class="hidden-md-and-up">
                <v-col cols="12" sm="8" md="5">
                  UMKM Siap Bermitra merupakan Sarana Pemerintah untuk mempertemukan investor
                  dengan UMKM yang terverifikasi, memfasilitasi kemitraan dalam investasi dan kerjasama usaha yang terstruktur dan terpercaya.
                </v-col>
              </v-row>
            </v-card-subtitle>
            <v-card-actions v-if="!currentUser" class="ml-4">
              <v-btn width="150px" @click="toLogin" color="success" dark>
                Masuk
              </v-btn>
              <v-btn
                class="ml-2"
                @click="toRegister"
                width="150px"
                color="primary"
                dark
              >
                DAFTAR
              </v-btn>
            </v-card-actions>
          </div>
          <v-spacer></v-spacer>
        </v-img>
      </v-responsive>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import FDinCarouselService from "@/services/apiservices/f-din-carousel-service";
import FileService from "@/services/apiservices/file-service";

export default {
  name: "UmkmBermitraMainCarousel",
  data() {
    return {
      itemsCarousel: [],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    toLogin() {
      this.$router.push("/login");
    },
    toRegister() {
      this.$router.push("/select-account-type");
    },
    fetchFDinCarousel() {
      FDinCarouselService.getAllFDinCarouselByTypePublic(2)
        .then((response) => {
          this.itemsCarousel = response.data.filter((x) => x.statusActive === true);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    lookupImageUrl(item) {
      if (item.avatarImage !== undefined && item.avatarImage !== "") {
        console.log("carousel UMKM");
        return FileService.image_url_medium(item.avatarImage);
      } else {
        return require("@/assets/images/no_image_available.jpeg");
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage !== undefined && item.avatarImage !== "") {
        return FileService.image_url_verylow(item.avatarImage);
      } else {
        return require("@/assets/images/no_image_available.jpeg");
      }
    },
  },
  created() {
    this.fetchFDinCarousel();
  },
};
</script>

<style scoped>
</style>